export default __webpack_public_path__ + "static/media/awards.3984504e.png";